import { createPortal } from 'react-dom';
import { Button } from './Button';
import type { ButtonVariant } from './Button';
import './ConfirmDialog.css';

type Props = {
  isOpen: boolean;
  title: string;
  message: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  variant?: 'danger' | 'warning' | 'info';
  isLoading?: boolean;
  messageAlign?: 'center' | 'left';
  buttonsAlign?: 'center' | 'space-between';
  hideButtons?: boolean;
  /** オーバーレイ (ダイアログの外側) のクリックで onCancel を呼ぶか。入力欄を持つダイアログで
   *  誤クリックによる入力の消失を防ぎたいときは false にする (既定 true)。 */
  closeOnOverlayClick?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  children?: React.ReactNode;
};

const variantToButtonVariant: Record<string, ButtonVariant> = {
  danger: 'danger',
  warning: 'primary',
  info: 'primary',
};

export function ConfirmDialog({
  isOpen,
  title,
  message,
  confirmLabel = '確認',
  cancelLabel = 'キャンセル',
  variant = 'danger',
  isLoading = false,
  messageAlign = 'center',
  buttonsAlign = 'center',
  hideButtons = false,
  closeOnOverlayClick = true,
  onConfirm,
  onCancel,
  children,
}: Props) {
  if (!isOpen) return null;

  return createPortal(
    <div className="confirm-dialog-overlay" onClick={closeOnOverlayClick ? onCancel : undefined}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <p className={`confirm-dialog-message${messageAlign === 'left' ? ' align-left' : ''}`}>
          {title && <strong>{title}</strong>}
          {title && <br />}
          {message}
        </p>
        {children}
        {!hideButtons && <div className="confirm-dialog-buttons" style={buttonsAlign !== 'center' ? { justifyContent: buttonsAlign } : undefined}>
          <Button
            variant="muted"
            size="md"
            onClick={onCancel}
            disabled={isLoading}
          >
            {cancelLabel}
          </Button>
          <Button
            variant={variantToButtonVariant[variant] || 'primary'}
            size="md"
            onClick={onConfirm}
            disabled={isLoading}
            loading={isLoading}
          >
            {isLoading ? '処理中...' : confirmLabel}
          </Button>
        </div>}
      </div>
    </div>,
    document.body
  );
}
